import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import Vuelidate from 'vuelidate'
import DatetimePicker from 'vuetify-datetime-picker'
import JsonExcel from 'vue-json-excel'
import io from 'socket.io-client'
import storeSockets from './modules/PABX/modules/monitor/modules/ramais/_store'
import { hostname } from '@/utils/hostname'

const ioInstance = io(`https://${hostname()}`, {
  secure: true,
  forceNew: true,
  reconnection: true,
  reconnectionDelay: 500,
  maxReconnectionAttempts: Infinity,
})

Vue.config.productionTip = false

Vue.use(Vuelidate)
Vue.use(DatetimePicker)
Vue.component('downloadExcel', JsonExcel)

const newVue = new Vue({
  // new Vue({
  router,
  store: storeSockets,
  vuetify,
  render: h => h(App),
}).$mount('#app')

ioInstance.on('connect', () => {
  newVue.$store.dispatch('SOCKET_Connect')
})

ioInstance.onAny((eventName, ...args) => {
  newVue.$store.dispatch(`SOCKET_${eventName}`, args[0])
})

export default newVue
export { ioInstance }
